$ = require 'jquery'
Elements = require './views/elements'
Backbone = require 'backbone'
Data = require './data'
Meta = require './views/meta'
OnePageScroll = require './views/one-page-scroll'
Logo = require './views/logo'
Nav = require './views/nav'
Menu = require './views/menu'
Bg = require './views/bg'
FirstAnime = require './views/first-anime'
WorksList = require './views/works-list'
WorksDetail = require './views/works-detail'
SpriteAnime = require './views/sprite-anime'
ToggleDetail = require './views/toggle-detail'
Map = require './views/map'
Deblurring = require './views/deblurring'
{ forEach, map, some, size, reduce, delay } = require 'lodash'
{ parse } = require '../components/query-string'
{ getParams, getParam, addParam, deleteParam, saveParams } = require './views/params'

module.exports =
class Router extends Backbone.Router

  routes:
    '(index.html)(?:query)'         : ''
    'about/(index.html)(?:query)'   : 'about'
    'service/(index.html)(?:query)' : 'service'
    'workflow/(index.html)(?:query)': 'workflow'
    'works/(index.html)(?:query)'   : 'works'
    'recruit/(index.html)(?:query)' : 'recruit'
    'contact/(index.html)(?:query)' : 'contact'

  menuParams  : 'menu'
  pageParams  : 'page'
  detailParams: 'detail'

  constructor: ->
    super

    @hasPushState = window.history and history.pushState
    @pathname     = location.pathname
    @pageName     = @pathname.replace 'index.html', ''
    Data.params  = map [0...size(@routes)], (i) -> {}

    if !@hasPushState and !location.hash
      location.href = "#{@pathname}##{@pageName}"

    if (@pageName isnt '/works/') or (getParam(@pageParams) is undefined)
      if @pageName isnt '/works/'
        addParam 4, @pageParams, 0
      else
        params = getParams()
        params[@pageParams] = 0
        location.href = "#{@pathname}?#{$.param params}"

    @isFirstVisit = map [0...size(@routes)], (i) -> true
    @location     = Data.location

    @meta          = Meta.getInstance()
    @onePageScroll = OnePageScroll.getInstance()
    @logo          = Logo.getInstance()
    @nav           = Nav.getInstance()
    @menu          = Menu.getInstance()
    @bg            = Bg.getInstance()
    @firstAnime    = FirstAnime.getInstance()
    @worksList     = WorksList.getInstance()
    @worksDetail   = WorksDetail.getInstance()

    @toggleDetails =
      '4': new ToggleDetail '.section-works'  , '.projects .button', 'works'
      '5': new ToggleDetail '.section-recruit', '.button'          , 'recruit'

    @spriteAnime =
      '2': map [1..3], (i) ->
        new SpriteAnime ".section-service .list-#{i} .thumb-img", { loop: true }

    if @pageName is '/'
      @nav.setLocation 0, false
      ga 'send', 'pageview'

    Elements.$window
      .one
        'pagesLoaded': =>
          @maps = []
          @maps.push new Map 'js-map-tokyo'  , 35.6764552, 139.706973
          $section = $ '.section'
          @deblurrings = map $section, (el) =>
            new Deblurring $(el)
        'splashEnded': =>
          if @hasPushState
            Backbone.history.start { pushState: true }
            query = location.search
            saveParams(Data.location, query) if query
          else
            Backbone.history.start { pushState: false }
            fragment = location.hash.replace '#', '/'
            Backbone.history.navigate fragment, true
      .on
        'firstAnimated': (e, target) =>
          @deblurrings[target + 1].redraw()
          switch target
            when 1
              @startSpriteAnime 2
            when 3
              @detailOpen 4
            when 4
              @detailOpen 5
            when 5
              @contactFirstAnimated()
        'bgJustBeforeEnd': @onBgJustBeforeEnd
        'bgEnded'        : @onBgEnded

  '': ->
    @goTo 0

  'about': ->
    @goTo 1

  'service': ->
    @goTo 2

  'workflow': ->
    @goTo 3

  'works': ->
    @toggleDetail 4
    @goTo 4
    @worksPageParams()
    @worksDetailParams()

  'recruit': ->
    @toggleDetail 5
    @goTo 5

  'contact': ->
    @goTo 6

  goTo: (target) ->
    @toggleMenu target

    return if @location is target

    @meta.set target
    @nav.setLocation target

    if @toggleDetails[@location]
      @toggleDetails[@location].off()

    if @location is 0
      @bg.on()
      @logo.show()
    else if target is 0
      @bg.off()
      @logo.hide()

    @onePageScroll.goTo target

    if target
      @bg.restart(target - 1)
    else
      @bg.stop()
      if @isFirstVisit[0]
        @isFirstVisit[0] = false

    if @spriteAnime[@location]
      forEach @spriteAnime[@location], (anime) ->
        anime.end()

    @location     = target
    Data.location = target

    ga 'send', 'pageview', "#{location.pathname}#{location.search}#{location.hash}"

  onBgJustBeforeEnd: (e, i) =>
    location     = i + 1
    isFirstVisit = @isFirstVisit[location]

    if @toggleDetails[location]
      @toggleDetails[location].on()

    if isFirstVisit
      @firstAnime.start i
    else
      @startSpriteAnime location
      @deblurrings[location].redraw()

    switch i
      when 5
        if isFirstVisit
          forEach @maps, (map) ->
            map.show()

    if isFirstVisit
      @isFirstVisit[location] = false

  onBgEnded: (e, i) =>
    @onePageScroll.mousewheeledLastTime = null

  toggleMenu: (target) ->
    if getParam(@menuParams) is 'open'
      @menu.open()
    else
      @menu.close()
      if @location isnt target
        forEach Data.params, (data) =>
          if data[@menuParams]
            delete data[@menuParams]

  toggleDetail: (target) ->
    return if (@location isnt target) or @isFirstVisit[target]
    detailParam = getParam @detailParams
    if detailParam
      @detailOpen target
    else
      @detailClose target

  detailOpen: (target) =>
    param = getParam @detailParams
    return unless param
    @toggleDetails[target].open param

  detailClose: (target) =>
    @toggleDetails[target].close()

  startSpriteAnime: (target) =>
    if @spriteAnime[target]
      forEach @spriteAnime[target], (anime) ->
        anime.start()

  ###
  works
  ###
  worksPageParams: ->
    param = getParam @pageParams
    if param and !@isFirstVisit[4]
      @worksList.goTo Number(param)

  worksDetailParams: ->
    param = getParam @detailParams
    if param and !@isFirstVisit[4]
      @worksDetail.goTo param

  ###
  contanct
  ###
  contactFirstAnimated: ->
    forEach @maps, (map) ->
      map.showMaker()



// WEBPACK FOOTER //
// ./webpack/requires/pc/router.coffee